import { gql } from '@apollo/client';

export const GET_SIZE_AND_WEIGHT_VEHICLES = gql`
  query GET_SIZE_AND_WEIGHT_VEHICLES($incidentId: ID!, $originatorId: ID!){
    initialCallInfo(incidentId: $incidentId, originatorId: $originatorId) {
      id
      sizeAndWeight {
        id
        powerUnit {
          id
        }
        trailers {
          id
        }
      }
    }
  }    
`